import { z } from "zod";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
export const demoNoteStatusSchema = z.enum(["DRAFT", "PUBLISHED", "ARCHIVED"]);
/** Açık geçiş tablosu (AGENTS.md §6): tabloda olmayan her geçiş INVALID_STATE_TRANSITION hatasıdır. */
export const DEMO_NOTE_TRANSITIONS = {
    DRAFT: ["PUBLISHED", "ARCHIVED"],
    PUBLISHED: ["ARCHIVED"],
    ARCHIVED: [],
};
export const demoNoteSchema = z.object({
    id: uuidSchema,
    noteNo: z.string().describe("Boşluksuz belge numarası"),
    title: z.string(),
    body: z.string(),
    status: demoNoteStatusSchema,
    createdBy: uuidSchema.nullable(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    version: z.number().int().describe("İyimser kilit sürümü"),
});
export const createDemoNoteSchema = z.object({
    title: z.string().trim().min(1, "Başlık zorunludur").max(200, "Başlık en fazla 200 karakter olabilir"),
    body: z.string().max(10_000).default(""),
});
export const updateDemoNoteSchema = z.object({
    title: z.string().trim().min(1).max(200).optional(),
    body: z.string().max(10_000).optional(),
    version: z.number().int().positive().describe("Okunan sürüm; uyuşmazsa VERSION_CONFLICT"),
});
export const changeDemoNoteStatusSchema = z.object({ status: demoNoteStatusSchema });
export const listDemoNotesQuerySchema = pageQuerySchema.extend({
    status: demoNoteStatusSchema.optional(),
    search: z.string().trim().max(100).optional(),
});
export const demoNotePageSchema = pageOf(demoNoteSchema);
export const demoNoteIdParamsSchema = z.object({ id: uuidSchema });
//# sourceMappingURL=demo-notes.js.map